// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_WORKSPACE } from "./action";

export function canCreateWorkspace(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_WORKSPACE);
}
